var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-map',{staticStyle:{"height":"30vh"},attrs:{"zoom":_vm.zoom,"center":_vm.center}},[_c('l-tile-layer',{attrs:{"url":_vm.url,"attribution":_vm.attribution}}),_c('l-marker',{attrs:{"lat-lng":_vm.markerLatLng}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }